import request from "../request";

export default {
 

  //热点-添加
  add(data) {
    return request.post("/spot/add", data);
  },

  //热点-修改
  edit(data) {
    return request.post("/spot/edit", data);
  },

  //热点-删除
  delete(data) {
    return request.post("/spot/delete", data);
  },
  
  //热点-删除
  updateLocation(data) {
    return request.post("/spot/updateLocation", data);
  },
  
  //热点-删除
  getSpotInfo(data) {
    return request.get("/spot/getSpotInfo", data);
  },
  
  
  
};
